import { ETripView } from '@/domain/Activities.domain';
import { TAttractionsState } from './domain';

export const DEFAULT_ATTRACTIONS_STATE: TAttractionsState = {
    fullList: [],
    showList: [],
    images: {},
    prices: {},
    hasMore: false,
    activityIds: '',
    params: {
        from: '',
        to: '',
    },
    tripView: ETripView.BROWSE_BY_ACTIVITY,
};
